import Axios from "axios";
import config from "configs/config";
import getText from "Translator";

const returnError = (err, lang) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: getText("generalerror", lang),
  };
  return data;
};
export const getHeadlines = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/headline/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getTitles = async (lang, newData, token) => {
  try {
    const url = config.apiserver + "/menu/gettitles";
    console.log(url);
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const submitTitle = async (lang, title, token) => {
  try {
    const url = config.apiserver + "/menu/storetitle";
    let responce = await Axios.post(url, title, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const editTitle = async (lang, title, token) => {
  try {
    const url = config.apiserver + "/menu/updatetitle";
    let responce = await Axios.post(url, title, {
      headers: {
        "x-access-token": token,
      },
    });
    console.log(responce.data);
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const deleteTitle = async (lang, newData, token) => {
  try {
    const url = config.apiserver + "/menu/deletetitle";
    let responce = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const updateTitleRowNumbers = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/menu/updatetitlerownumbers/";
    let responce = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getCapsules = async (lang, newData, token) => {
  try {
    const url = config.apiserver + "/menu/getcapsules/";

    let responce = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    console.log(responce.data);
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const updateCapsuleRowNumbers = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/menu/updatecapsulerownumbers/";
    let responce = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const submitCapsule = async (lang, capsule, token) => {
  try {
    const url = config.apiserver + "/menu/storecapsule";
    let responce = await Axios.post(url, capsule, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const editCapsules = async (lang, capsule, token) => {
  try {
    const url = config.apiserver + "/menu/updatecapsule";
    let responce = await Axios.post(url, capsule, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getCapsule = async (lang, id, token) => {
  try {
    const url = config.apiserver + "/getcapsule/" + id + "/" + lang;
    let responce = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const deleteCapsule = async (lang, newData, token) => {
  try {
    const url = config.apiserver + "/menu/deletecapsule/";
    let responce = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getAllTitleAndCapsules = async (lang, token) => {
  try {
    const url = config.apiserver + "/menu/getforpermission/";
    console.log(url)
    let responce = await Axios.post(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getForms = async (lang, newData, token) => {
  try {
    const url = config.apiserver + "/menu/getforms/";

    let responce = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    console.log(responce.data);
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getFormsByPagePermissions = async (lang, newData, token) => {
  try {
    const url = config.apiserver + "/menu/getformsbypermissions/";

    let responce = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    console.log(responce.data);
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};


export const storeForm = async (lang, newData, token) => {
  try {
    let url = config.apiserver + "/menu/storeform/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const updateForm = async (lang, newData, token) => {
  try {
    let url = config.apiserver + "/menu/updateform/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const deleteForm = async (lang, newData, token) => {
  try {
    let url = config.apiserver + "/menu/deleteform/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const storePage = async (lang, newData, token) => {
  try {
    let url = config.apiserver + "/menu/storepage/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const updatePage = async (lang, newData, token) => {
  try {
    let url = config.apiserver + "/menu/updatepage/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const deletePage = async (lang, newData, token) => {
  try {
    let url = config.apiserver + "/menu/deletepage/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const updatePageRowNumbers = async (lang, newData, token) => {
  try {
    let url = config.apiserver + "/menu/updatepagerownumbers/";
    let res = await Axios.post(url, newData, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getHelpPages = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/menu/getcapsulehelppages/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getMainPages = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/menu/getcapsulemainpages/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getCapsuleSubForms = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/menu/getcapsulesubforms/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getFormPages = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/menu/getformpages/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getFileAccessUser = async (lang, query, token) => {
  try {
    const url = config.apiserver + `/menu/getfileaccessuser?user=${query.user}&capsule=${query.capsule}&permission=${query.permission}`;
    console.log(url);
    let responce = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const storeFileAccessUser = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/menu/storefileaccessuser/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const getPageAccessAssistant = async (lang, query, token) => {
  try {
    const url = config.apiserver + `/menu/getpageaccessassistant?user=${query.user}&capsule=${query.capsule}&permission=${query.permission}`;
    console.log(url);
    let responce = await Axios.get(url, {
      headers: {
        "x-access-token": token,
      },
    });
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const storePageAccessAssistant = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/menu/storepageaccessassistant/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};